import { useBreakpoints } from "./useBreakpoints"
const useWhatMenuShow = (forceToShowTabletMenu = false) => {
  const { isMobile, isTablet } = useBreakpoints()

  const getMenu = () => {
    if (isMobile) {
      return "mobile"
    }

    if (isTablet || forceToShowTabletMenu) {
      return "tablet"
    }

    return "desktop"
  }

  return getMenu()
}

export default useWhatMenuShow
